import { Search, X } from 'lucide-react';

/**
 * Search input with built-in search icon and optional clear button.
 *
 * @example
 * <SearchInput
 *   value={query}
 *   onChange={(e) => setQuery(e.target.value)}
 *   onClear={() => setQuery('')}
 *   placeholder="Search drives..."
 * />
 */
const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder = 'Search...',
  className = '',
  ...props
}) => (
  <div
    className={[
      'relative flex items-center rounded-md border border-edge bg-surface transition-colors duration-150',
      'hover:border-accent/50 focus-within:border-accent/50 focus-within:ring-1 focus-within:ring-inset focus-within:ring-accent/50',
      className,
    ]
      .filter(Boolean)
      .join(' ')}
  >
    <span className="pointer-events-none absolute left-3 text-content-muted">
      <Search size={16} />
    </span>

    <input
      type="search"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={[
        'w-full bg-transparent pl-9 pr-3 py-2 text-sm text-content outline-none',
        'placeholder:text-content-faint',
        '[&::-webkit-search-cancel-button]:hidden',
        onClear && value ? 'pr-8' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    />

    {onClear && value && (
      <button
        type="button"
        onClick={onClear}
        className="absolute right-2 inline-flex items-center justify-center size-5 rounded text-content-muted hover:text-content transition-colors"
        aria-label="Clear search"
      >
        <X size={14} />
      </button>
    )}
  </div>
);

export default SearchInput;
